__webpack_require__.p = "https://prod.reporting.agids.amazon.dev/";